import orciCareLogo from "./assets/header-logo-2.jpg";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import DehazeIcon from "@mui/icons-material/Dehaze";
import { useSelector } from "react-redux";
import { Badge, IconButton } from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import { useNavigate } from "react-router-dom";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";

const Header = ({ collapsed, setCollapsed }) => {
  const user_name = useSelector((state) => state.auth?.authData?.full_name);
  const { practice_name, isAdmin } = useSelector((state) => ({
    practice_name: state.auth?.authData?.selected_practice_name,
    isAdmin: state.auth?.authData?.isAdmin,
  }));
  const navigate = useNavigate();
  return (
    <header className="header-container">
      <IconButton onClick={() => setCollapsed(false)} className="nav-icon">
        <DehazeIcon fontSize="large" />
      </IconButton>
      <div className="header-logo">
        <img
          width={"192"}
          height={64}
          src={orciCareLogo}
          alt="Orci Care logo"
        />
      </div>
      <div className="header-details">
        <div className="header-dr">
          <p className="header-name">{user_name}</p>
        </div>
        <div className="setting">
          <IconButton onClick={() => navigate("/settings")}>
            <SettingsIcon />
          </IconButton>
          {isAdmin ? (
            <IconButton onClick={() => navigate("/admin/dashboard")}>
              <AdminPanelSettingsIcon />
            </IconButton>
          ) : null}
        </div>
        <div className="header-clinic">
          <p className="header-name">{practice_name?.toLowerCase()}</p>
        </div>
        <div className="header-notify">
          <Badge badgeContent={0} color="secondary">
            <IconButton>
              <NotificationsNoneIcon fontSize={"large"} />
            </IconButton>
          </Badge>
        </div>
      </div>
    </header>
  );
};

export default Header;
